(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
  
        this.setHeaderHeight();
  
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
  
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };
  
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
  
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
  
        this.createObserver();
      }
  
      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
  
      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }
  
      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
  
        observer.observe(this.header);
      }
  
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
  
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
  
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
  
        this.currentScrollTop = scrollTop;
      }
  
      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
  
      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }
  
      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }
  
    customElements.define('sticky-header', StickyHeader);
    
    // Enhanced mega menu and mobile drawer functionality
    document.addEventListener('DOMContentLoaded', function() {
      // Fix mega menu positioning and containment
      const megaMenus = document.querySelectorAll('.mega-menu');
      const menuItems = document.querySelectorAll('.header__menu-item');
      const isMobile = window.innerWidth < 990;
      
      // Mobile drawer menu functionality
      const toggleMobileMenu = document.getElementById('mobile-menu-toggle');
      const mobileDrawerMenu = document.querySelector('.mobile-drawer-menu');
      const mobileDrawerOverlay = document.querySelector('.mobile-drawer-overlay');
      const closeDrawerButton = document.querySelector('.mobile-drawer-close');
      
      // Function to close the mobile menu
      function closeMobileMenu(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        mobileDrawerMenu.classList.remove('active');
        mobileDrawerOverlay.classList.remove('active');
        document.body.style.overflow = '';
        return false;
      }
      
      // Open mobile drawer menu
      if (toggleMobileMenu) {
        toggleMobileMenu.addEventListener('click', function(e) {
          mobileDrawerMenu.classList.add('active');
          mobileDrawerOverlay.classList.add('active');
          document.body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
          e.stopPropagation(); // Prevent the click from bubbling to document
        });
      }
      
      // Close mobile drawer menu via button
      if (closeDrawerButton) {
        closeDrawerButton.addEventListener('click', closeMobileMenu);
      }
      
      // Close menu when clicking overlay
      if (mobileDrawerOverlay) {
        // Handle mouse events
        mobileDrawerOverlay.addEventListener('click', closeMobileMenu);
        
        // Handle touch events specifically for mobile
        mobileDrawerOverlay.addEventListener('touchstart', function(e) {
          e.preventDefault();
          closeMobileMenu(e);
        }, { passive: false });
      }
      
      // Close menu when clicking anywhere outside the menu container
      document.addEventListener('click', function(e) {
        // Only process if the menu is currently open
        if (!mobileDrawerMenu || !mobileDrawerMenu.classList.contains('active')) {
          return;
        }
        
        // Check if click is outside the menu and toggle button
        if (!mobileDrawerMenu.contains(e.target) && 
            (!toggleMobileMenu || !toggleMobileMenu.contains(e.target))) {
          e.preventDefault(); // Prevent any default actions
          closeMobileMenu(e);
        }
      }, true); // Use capture phase to handle event before it reaches other elements
      
      // Prevent clicks inside the menu from closing it
      if (mobileDrawerMenu) {
        mobileDrawerMenu.addEventListener('click', function(e) {
          e.stopPropagation(); // Prevent the click from bubbling to document
        });
      }
      
      // Handle mobile submenu toggling
      const mainMenuItems = document.querySelectorAll('.mobile-drawer-menu-item.has-submenu');
      const subMenuItems = document.querySelectorAll('.mobile-drawer-submenu-item.has-submenu');
      
      // Add click event to main menu items
      mainMenuItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
          // Only handle clicks on the item itself or the arrow, not child links
          if (e.target.closest('.mobile-drawer-submenu')) {
            return;
          }
          
          const isExpanded = item.classList.contains('expanded');
          
          // Close all other open items at the same level first
          mainMenuItems.forEach(function(otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('expanded');
            }
          });
          
          // Toggle this item
          item.classList.toggle('expanded', !isExpanded);
          e.stopPropagation(); // Prevent event from bubbling to parent items
        });
      });
      
      // Add click event to submenu items
      subMenuItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
          // Ignore clicks on links
          if (e.target.tagName === 'A') {
            return;
          }
          
          const isExpanded = item.classList.contains('expanded');
          
          // Close all other open items at the same level first
          const siblings = Array.from(item.parentNode.querySelectorAll('.mobile-drawer-submenu-item.has-submenu'));
          siblings.forEach(function(sibling) {
            if (sibling !== item) {
              sibling.classList.remove('expanded');
            }
          });
          
          // Toggle this item
          item.classList.toggle('expanded', !isExpanded);
          e.stopPropagation(); // Prevent event from bubbling to parent items
        });
      });
      
      // Make menu items clickable to navigate
      const drawerMenuLinks = document.querySelectorAll('.mobile-drawer-submenu-link, .mobile-drawer-subsubmenu-link');
      drawerMenuLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.stopPropagation(); // Don't trigger the parent item's click event
          // Close the menu after navigating
          mobileDrawerMenu.classList.remove('active');
          mobileDrawerOverlay.classList.remove('active');
          document.body.style.overflow = '';
        });
      });
      
      // Add close button to each mega menu for mobile
      if (isMobile) {
        megaMenus.forEach(function(menu) {
          const closeButton = document.createElement('button');
          closeButton.className = 'mega-menu__close';
          closeButton.innerHTML = '<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
          closeButton.setAttribute('aria-label', 'Close menu');
          menu.insertBefore(closeButton, menu.firstChild);
          
          closeButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            menu.style.opacity = '0';
            menu.style.visibility = 'hidden';
            setTimeout(function() {
              menu.style.display = 'none';
            }, 300);
          });
        });
      }
      
      // Function to position mega menus correctly
      function positionMegaMenus() {
        // Get the header position and dimensions
        const header = document.querySelector('.header');
        const navContainer = document.querySelector('.header__nav-container');
        const headerRect = header.getBoundingClientRect();
        
        // Calculate the position where mega menus should appear
        const topPosition = navContainer ? navContainer.getBoundingClientRect().bottom : headerRect.bottom;
        
        // Apply same fixed position to all mega menus
        megaMenus.forEach(function(menu) {
          // Set the top position based on the header nav container
          menu.style.top = `${topPosition}px`;
          
          // Ensure it's always centered horizontally
          menu.style.left = '50%';
          menu.style.transform = 'translateX(-50%)';
          menu.style.width = window.innerWidth >= 1500 ? '90vw' : '95vw';
          menu.style.maxWidth = '1400px';
        });
      }
      
      // Handle hover interactions on desktop, click on mobile
      menuItems.forEach(function(item, index) {
        const megaMenu = item.querySelector('.mega-menu');
        const menuLink = item.querySelector('.header__menu-link');
        
        if (megaMenu) {
          // Add a data attribute to track which menu item this belongs to
          megaMenu.setAttribute('data-menu-index', index);
          
          if (window.innerWidth >= 990) {
            // Desktop behavior (hover)
            item.addEventListener('mouseenter', function() {
              // First hide all other mega menus
              megaMenus.forEach(function(menu) {
                if (menu !== megaMenu) {
                  menu.style.opacity = '0';
                  menu.style.visibility = 'hidden';
                  setTimeout(function() {
                    menu.style.display = 'none';
                  }, 300);
                }
              });
              
              // Position all menus (important to do after hiding others)
              positionMegaMenus();
              
              // Then show this one
              megaMenu.style.display = 'block';
              // Use a small timeout to ensure display:block has applied
              setTimeout(function() {
                megaMenu.style.opacity = '1';
                megaMenu.style.visibility = 'visible';
              }, 10);
            });
            
            item.addEventListener('mouseleave', function(e) {
              // Check if we're hovering over the mega menu itself
              if (!e.relatedTarget || !e.relatedTarget.closest('.mega-menu')) {
                megaMenu.style.opacity = '0';
                megaMenu.style.visibility = 'hidden';
                setTimeout(function() {
                  megaMenu.style.display = 'none';
                }, 300);
              }
            });
            
            // Also add listener to the mega menu itself
            megaMenu.addEventListener('mouseleave', function(e) {
              if (!e.relatedTarget || !e.relatedTarget.closest('.header__menu-item')) {
                megaMenu.style.opacity = '0';
                megaMenu.style.visibility = 'hidden';
                setTimeout(function() {
                  megaMenu.style.display = 'none';
                }, 300);
              }
            });
          } else {
            // Mobile behavior (click)
            menuLink.addEventListener('click', function(e) {
              if (megaMenu) {
                e.preventDefault();
                
                // Hide all other mega menus first
                megaMenus.forEach(function(menu) {
                  if (menu !== megaMenu) {
                    menu.style.opacity = '0';
                    menu.style.visibility = 'hidden';
                    setTimeout(function() {
                      menu.style.display = 'none';
                    }, 300);
                  }
                });
                
                // Position all menus
                positionMegaMenus();
                
                // Show this one
                megaMenu.style.display = 'block';
                setTimeout(function() {
                  megaMenu.style.opacity = '1';
                  megaMenu.style.visibility = 'visible';
                }, 10);
              }
            });
          }
        }
      });
      
      // Close mobile mega menu when clicking outside
      document.addEventListener('click', function(e) {
        if (window.innerWidth < 990) {
          if (!e.target.closest('.mega-menu') && !e.target.closest('.header__menu-item')) {
            megaMenus.forEach(function(menu) {
              menu.style.opacity = '0';
              menu.style.visibility = 'hidden';
              setTimeout(function() {
                menu.style.display = 'none';
              }, 300);
            });
          }
        }
      });
      
      // Adjust on window resize
      window.addEventListener('resize', function() {
        const wasMobile = isMobile;
        isMobile = window.innerWidth < 990;
        
        // If switching between mobile and desktop views
        if (wasMobile !== isMobile) {
          location.reload(); // Reload to apply the correct behavior
        } else {
          positionMegaMenus();
          
          // If any mega menu is currently visible, reposition it
          megaMenus.forEach(function(menu) {
            if (menu.style.visibility === 'visible') {
              positionMegaMenus();
            }
          });
        }
      });
      
      // Also reposition on scroll to handle sticky header changes
      window.addEventListener('scroll', function() {
        // Only reposition if a mega menu is visible
        const visibleMenu = Array.from(megaMenus).find(menu => 
          menu.style.visibility === 'visible' && 
          menu.style.display === 'block'
        );
        
        if (visibleMenu) {
          positionMegaMenus();
        }
      });
      
      // Initial positioning
      positionMegaMenus();
      
      // Preload collection images for better performance
      function preloadCollectionImages() {
        const imageContainers = document.querySelectorAll('.mega-menu__image-container');
        imageContainers.forEach(function(container) {
          const img = container.querySelector('img');
          if (img && img.getAttribute('src')) {
            const preloadImg = new Image();
            preloadImg.src = img.getAttribute('src');
          }
        });
      }
      
      // Handle image swapping when hovering over submenu items
      document.addEventListener('DOMContentLoaded', function() {
        const menuItems = document.querySelectorAll('.mega-menu__item[data-image-url]');
        
        menuItems.forEach(function(item) {
          const imageUrl = item.getAttribute('data-image-url');
          if (!imageUrl) return;
          
          item.addEventListener('mouseenter', function() {
            const column = item.closest('.mega-menu__column');
            if (!column) return;
            
            // Add active class to this item
            item.classList.add('active');
            
            // Remove active class from other items in this column
            column.querySelectorAll('.mega-menu__item.active').forEach(function(activeItem) {
              if (activeItem !== item) {
                activeItem.classList.remove('active');
              }
            });
            
            const columnImage = column.querySelector('.mega-menu__image');
            if (columnImage) {
              // Store the original source if not already stored
              if (!columnImage.hasAttribute('data-stored-src')) {
                columnImage.setAttribute('data-stored-src', columnImage.getAttribute('src'));
              }
              
              // Change the image with a fade effect
              columnImage.style.opacity = '0.5';
              setTimeout(function() {
                columnImage.setAttribute('src', imageUrl);
                columnImage.style.opacity = '1';
              }, 150);
            }
          });
          
          // Handle column mouseleave
          const column = item.closest('.mega-menu__column');
          if (column) {
            column.addEventListener('mouseleave', function() {
              // Reset image to original on column mouseleave
              const columnImage = column.querySelector('.mega-menu__image');
              if (columnImage && columnImage.hasAttribute('data-stored-src')) {
                // Restore with fade effect
                columnImage.style.opacity = '0.5';
                setTimeout(function() {
                  columnImage.setAttribute('src', columnImage.getAttribute('data-stored-src'));
                  columnImage.style.opacity = '1';
                  // Remove the stored source
                  columnImage.removeAttribute('data-stored-src');
                }, 150);
              }
              
              // Remove active class from all items
              column.querySelectorAll('.mega-menu__item.active').forEach(function(activeItem) {
                activeItem.classList.remove('active');
              });
            });
          }
        });
        
        // Preload images for better performance
        preloadCollectionImages();
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
